import React, { useEffect, useState } from 'react';
import { connect } from 'formik';

// Esse componente foi criado pois, por algum motivo, o biblioteca do formik não possuí uma função de callback para quando a validação falha...


/* Deve ser usado da seguinte maneira
<Formik {...formikProps}>
    <SubmitErrorHandler
        formik={formik}
        onSubmitError={onSubmitErrorCallback} />
</Formik>
*/
interface SubmitErrorHandlerProps {
  onSubmitError : ()=>void;
  formik: any
}
const SubmitErrorHandler: React.FC<SubmitErrorHandlerProps> = ({onSubmitError, formik}) => {
  const { submitCount, isValid, isSubmitting } = formik
  const [lastHandled, setLastHandled] = useState(0);
  useEffect(() => {
    if (submitCount > lastHandled && !isValid && !isSubmitting) {
      setLastHandled(submitCount);
      onSubmitError();
      
    }
  }, [submitCount, isValid, onSubmitError, lastHandled]);

  return null;
};
export default SubmitErrorHandler;